module.exports = __webpack_public_path__ + "img/g2.5758e8fb.png";